<script setup>
import Input from 'dashboard/components-next/input/Input.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import CompanySortMenu from './components/CompanySortMenu.vue';

defineProps({
  showSearch: { type: Boolean, default: true },
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, required: true },
  headerSubtitle: { type: String, default: '' },
  activeSort: { type: String, default: 'last_activity_at' },
  activeOrdering: { type: String, default: '' },
});

const emit = defineEmits(['search', 'update:sort', 'create']);
</script>

<template>
  <header class="sticky top-0 z-10 px-4 md:px-6 bg-n-surface-1">
    <div class="flex flex-col w-full gap-4 pt-6 pb-4 mx-auto max-w-7xl">
      <div class="flex flex-wrap items-center justify-between w-full gap-3">
        <div class="flex flex-col min-w-0 gap-0.5">
          <h1
            class="text-xl font-semibold tracking-tight truncate text-n-slate-12"
          >
            {{ headerTitle }}
          </h1>
          <p
            v-if="headerSubtitle"
            class="mb-0 text-sm truncate text-n-slate-11"
          >
            {{ headerSubtitle }}
          </p>
        </div>
        <Button
          :label="$t('COMPANIES.ACTIONS.CREATE')"
          icon="i-lucide-plus"
          size="sm"
          @click="emit('create')"
        />
      </div>

      <div class="flex flex-wrap items-center w-full gap-2">
        <div v-if="showSearch" class="w-full sm:w-72">
          <Input
            :model-value="searchValue"
            type="search"
            :placeholder="$t('COMPANIES.SEARCH_PLACEHOLDER')"
            :custom-input-class="[
              'h-9 bg-n-alpha-2 dark:bg-n-solid-1 ltr:!pl-8 !py-1 rtl:!pr-8',
            ]"
            class="w-full"
            @input="emit('search', $event.target.value)"
          >
            <template #prefix>
              <Icon
                icon="i-lucide-search"
                class="absolute -translate-y-1/2 text-n-slate-11 size-4 top-1/2 ltr:left-2 rtl:right-2"
              />
            </template>
          </Input>
        </div>
        <div class="flex items-center gap-2 ltr:ml-auto rtl:mr-auto">
          <CompanySortMenu
            :active-sort="activeSort"
            :active-ordering="activeOrdering"
            @update:sort="emit('update:sort', $event)"
          />
        </div>
      </div>
    </div>
  </header>
</template>
